<template>
    <SectionBase v-if="hasItems" class="YourInterestsSection" :title="$t('title')">
        <template v-slot:titleExtra>
            <div class="info" @click="modify()">
                {{ $t('modify') }}
            </div>
        </template>

        <template v-slot:items>
            <CoursePreview v-for="item of items" :key="item.courseId" v-bind="item" />
            <VideoPreview
                v-for="video of videos"
                :key="video.videoId"
                :video-id="video.videoId"
                :lifeskill-id="video.lifeskillId"
            />
        </template>
    </SectionBase>
</template>

<translations>
  title: 'Your Interests'
  title_no: 'Dine interesser'

  modify: modify
  modify_no: endre
</translations>

<script>
import SectionBase from './SectionBase';
import CoursePreview from './CoursePreview';
import VideoPreview from './VideoPreview';

export default {
    components: { SectionBase, CoursePreview, VideoPreview },
    computed: {
        items() {
            return this.$store.getters['moduleApp/recommendedItems'] || [];
        },

        videos() {
            return this.$store.getters['moduleApp/followedVideos'].slice(0, 20) || [];
        },
        hasItems() {
            return this.items.length + this.videos.length;
        }
    },
    async mounted() {
        await this.$store.dispatch('moduleApp/loadAllVideos');
    },
    methods: {
        modify() {
            this.$router.push({
                name: 'FollowLifeskillView'
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.info {
    color: rgba(white, 0.5);
    margin-left: 1em;
    cursor: pointer;
}
</style>
